// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__WCeSj","left":"InfoRow_left__3A_KX"};